var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{ref:"cascader",attrs:{"options":_vm.list,"load-data":_vm.loadData,"size":"small","change-on-select":"","placeholder":_vm.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }